import {
  ICompaniesChangesState,
  initialCompaniesChangesState,
} from '@myStore/companies/changes/companies-changes.state';
import {
  CompaniesChangesActions,
  ECompaniesChangesActions,
} from '@myStore/companies/changes/companies-changes.actions';

export const companiesChangesReducers = (
  state = initialCompaniesChangesState,
  actions: CompaniesChangesActions
): ICompaniesChangesState => {
  switch (actions.type) {
    case ECompaniesChangesActions.CreateCompanyRequest:
    case ECompaniesChangesActions.CreateVacancyRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errors: null,
      };
    case ECompaniesChangesActions.CreateCompanySuccess:
    case ECompaniesChangesActions.CreateVacancySuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
        errors: null,
      };
    case ECompaniesChangesActions.CreateCompanyFailure:
    case ECompaniesChangesActions.CreateVacancyFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
      };
    case ECompaniesChangesActions.ClearCreateCompanies:
    case ECompaniesChangesActions.ClearCreateVacancies:
      return {
        ...state,
        isLoading: false,
        errors: null,
        success: false,
      };
    default:
      return state;
  }
};
